import { React, useState, useEffect } from "react";

const PopUpAviatorResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "";

        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">
                    <div style={{ display: marketType == 51 || marketType == 11 ? "" : "none" }} >
                        <div class="left-content">
                            <div class="card">
                                <div class="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>

                                <div class="card-body">
                                    <div class="ExMainCardbundle" style={{ textAlign: "-webkit-center" }}>
                                        <div class="font-familyAVE absoluteAve flexAve flex-colAve items-center drop-shadow-mdAve font-blackAve text-strokeAve tracking-wideAve w-100 text-rose-600Ave AnimateOdds">
                                            <span style={{ fontSize: "20px" }}>CRASHED At!</span>
                                            <div class="text-strokeblackAve" style={{ fontSize: "70px" }}> {resultData?.result}X</div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div class="card-body">
                                    <div style={{ textAlign: "-webkit-center" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ paddingRight: "10px" }}>
                                                        <div class="cards">
                                                            <div class="cardsText"> </div>

                                                            <div class="font-familyAVE absoluteAve flexAve flex-colAve items-center drop-shadow-mdAve font-blackAve text-strokeAve tracking-wideAve w-100 text-rose-600Ave AnimateOdds">
                                                                <div
                                                                    class="flexAve items-endAve gap-1Ave w-42 text-strokeblackAve"
                                                                    style={{ fontSize: "40px" }}
                                                                >
                                                                    CRASHED at {resultData?.result}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
            .text-strokeblackAve {
                text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
            }
            `}</style>
        </div>
    );
};

export default PopUpAviatorResults;

